<template>
  <v-card
    class="card"
    @mouseover="mouseOver = true"
    @mouseleave="mouseOver = false"
  >
    <div class="image-wrapper">
      <div></div>
      <v-card-actions
        v-show="mouseOver"
        class="actions"
        v-if="!this.isMerchantView"
      >
        <div class="delete icon">
          <v-icon
            @click="
              $emit('delete', {
                id: cardData._id,
                name: cardData.name[0],
                product: cardData,
              })
            "
            class="icon"
            >mdi-close</v-icon
          >
        </div>
        <div class="share" v-if="!this.isIframe">
          <v-btn @click="shareProduct">Share on WhatsApp</v-btn>
        </div>
      </v-card-actions>
      <img :src="cardData.img" class="img" />
    </div>

    <v-menu v-if="false" transition="slide-y-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon color="rgb(20, 200, 200)">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-menu offset-y offset-x bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-title v-bind="attrs" v-on="on"
                >Move to</v-list-item-title
              >
            </template>

            <v-list>
              <v-list-item v-show="!filterdCategories.length">
                <v-list-item-title>No Collections</v-list-item-title>
              </v-list-item>

              <v-list-item
                v-for="(category, index) in filterdCategories"
                :key="index"
                @click="moveProductToCategory(category)"
              >
                <v-list-item-title>{{ category }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item>
        <v-list-item>
          <v-list-item-title
            class="clickable"
            :class="{ disabled: cardData.sharedDataId }"
            @click="
              $emit('share', { id: cardData._id, name: cardData.name[0] })
            "
            >Share</v-list-item-title
          >
        </v-list-item>
        <v-list-item>
          <v-list-item-title
            class="clickable"
            @click="
              $emit('delete', { id: cardData._id, name: cardData.name[0] })
            "
            >Delete</v-list-item-title
          >
        </v-list-item>
      </v-list>
    </v-menu>

    <v-card-text class="card-title" @click="openUrl(cardData.productUrl)">{{
      cardData.name ? cardData.name[0] : ""
    }}</v-card-text>

    <div v-if="cardData.price.previousValue">
      <v-card-text class="previous-price price">{{
        cardData.price.previousValue
      }}</v-card-text>
      <v-card-text class="current-price price">{{
        cardData.price.value
      }}</v-card-text>
    </div>
    <v-card-text v-else
      ><span class="price">{{ cardData.price.value }}</span> <br />
      {{ cardData.merchantUrl }}</v-card-text
    >

    <v-card-actions
      class="card-actions"
      v-if="!this.isMerchantView && !this.isIframe"
    >
      <v-tooltip bottom :disabled="!cardData.category">
        <template v-slot:activator="{ on, attrs }">
          <div color="primary" dark v-bind="attrs" v-on="on">
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-title v-bind="attrs" v-on="on">
                  <v-icon :color="categorized">mdi-tag-outline</v-icon>
                </v-list-item-title>
              </template>
              <v-list>
                <v-list-item v-show="!filterdCategories.length">
                  <v-list-item-title>No Collections</v-list-item-title>
                </v-list-item>

                <v-list-item
                  v-for="(category, index) in filterdCategories"
                  :key="index"
                  @click="moveProductToCategory(category)"
                >
                  <v-list-item-title>{{ category }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <span>{{ cardData.category ? cardData.category[0] : "" }}</span>
      </v-tooltip>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <div
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
            @click="setAlarm()"
          >
            <v-list-item-title v-bind="attrs" v-on="on">
              <v-icon :color="alarmColor">mdi-bell</v-icon>
            </v-list-item-title>
          </div>
        </template>
        <span>Get discount and "back in stock" alerts</span>
      </v-tooltip>
    </v-card-actions>
    <!-- <v-card-actions v-if="!cardData.sharedDataId" class="card-actions">
      <v-btn icon @click="show = !show">
        <v-badge color="rgb(20 200 200)" :content="commentCount" :value="commentCount" overlap>
          <v-icon>mdi-comment</v-icon>
        </v-badge>
      </v-btn>
      <div class="icon">
        <v-badge color="rgb(20 200 200)" :content="likesCount" :value="likesCount" overlap>
          <v-icon>mdi-fire</v-icon>
        </v-badge>
      </div>
      <div class="icon">
        <v-badge color="rgb(20 200 200)" :content="mehCount" :value="mehCount" overlap>
          <v-icon>mdi-emoticon-neutral-outline</v-icon>
        </v-badge>
      </div>
    </v-card-actions> -->
    <!-- <v-expand-transition v-if="cardData.sharedDataId" class="comment-section">
      <div v-show="show">
        <div class="comment-box">
          <v-textarea label="Write a comment" no-resize rows="1" color="rgb(20, 200, 200)" v-model="comment" @keypress.enter.prevent="postComment(cardData.sharedDataId)"></v-textarea>
          <v-btn icon @click="postComment(cardData.sharedDataId)" :disabled="this.comment.length < 1">
            <v-icon>mdi-send</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <div v-if="cardData.data">
          <CommentDisplay :comment="product" :key="i" v-for="(product, i) in cardData.data.comments" @deleteComment="deleteComment" class="comment" />
        </div>
      </div>
    </v-expand-transition> -->
  </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "card",
  data() {
    return {
      mouseOver: false,
      show: false,
      dialog: true,
      windowWidth: window.innerWidth,
      comment: "",
    };
  },
  props: {
    cardData: {
      type: Object,
    },
    isIframe: Boolean,
    isMerchantView: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(["categories"]),
    ...mapGetters([
      "mehByProductId",
      "likesByProductId",
      "email",
      "alarmProducts",
      "products",
    ]),

    hasAlarm() {
      return this.alarmProducts[this.cardData.productId];
    },
    alarmColor() {
      return this.hasAlarm ? "rgb(20, 200, 200)" : null;
    },
    likesCount() {
      return this.likesByProductId[this.cardData.productId]
        ? this.likesByProductId[this.cardData.productId].length
        : 0;
    },
    mehCount() {
      return this.mehByProductId[this.cardData.productId]
        ? this.mehByProductId[this.cardData.productId].length
        : 0;
    },
    commentCount() {
      return this.cardData.data
        ? Object.values(this.cardData.data.comments).length
        : 0;
    },
    filterdCategories() {
      return this.categories.filter(
        (category) =>
          !this.cardData.category ||
          !this.cardData.category.length ||
          category !== this.cardData.category[0]
      );
    },
    categorized() {
      return this.cardData.category ? "rgb(20, 200, 200)" : null;
    },
  },
  methods: {
    ...mapActions([
      "editProduct",
      "addComment",
      "removeComment",
      "addBanner",
      "removeProductAlarm",
    ]),
    setAlarm() {
      const alarmProduct = { productId: this.cardData.productId };
      if (this.alarmProducts[this.cardData.productId]) {
        this.removeProductAlarm(alarmProduct);
      } else {
        this.$emit("setProductAlarm", alarmProduct);
      }
    },
    shareProduct() {
      this.$emit("share", { productId: this.cardData.productId });
    },
    openUrl(url) {
      window.open(url);
    },
    async moveProductToCategory(category) {
      try {
        this.cardData.category = [category];
        const newProduct = JSON.parse(JSON.stringify(this.cardData));
        delete newProduct.data;
        await this.editProduct(newProduct);
        const banner = {
          type: "success",
          text: `Product has been moved to "${category}"`,
          dismiss: true,
        };
        this.addBanner(banner);
      } catch {
        const banner = {
          type: "error",
          text: "Oops something went wrong..please try again.",
          dismiss: true,
        };
        this.addBanner(banner);
      }
    },
    postComment(sharedDataId) {
      this.addComment({
        email: this.email,
        date: Date.now(),
        value: this.comment,
        sharedDataId: sharedDataId,
        isMyProduct: true,
      });
      this.comment = "";
    },
    deleteComment(commentId) {
      this.removeComment({
        id: commentId,
        sharedDataId: this.cardData.sharedDataId,
        isMyProduct: true,
      });
    },
  },
};
</script>

<style scoped>
.card {
  display: flex;
  flex: 1;
}
.card-title:hover {
  cursor: pointer;
  text-decoration: underline;
}
.card-title {
  display: inline-block;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
.price {
  font-weight: 1000;
}
.previous-price {
  text-decoration: line-through;
}
.current-price {
  color: red;
}
.comment-section {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.comment {
  display: flex;
  flex: 1;
}
.card-actions {
  display: flex;
  justify-content: flex-end;
}
.comment-box {
  display: flex;
  align-items: center;
  padding: 5px;
}
.icon {
  cursor: pointer;
}
.clickable {
  cursor: pointer;
}
.disabled {
  opacity: 0.5;
  cursor: default;
}
.delete {
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
}
.actions {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  z-index: 2;
  position: absolute;
  width: 100%;
  height: 100%;
}

.image-wrapper {
  position: relative;
}
.img {
  width: 100%;
  max-height: 400px;
}
.v-list-item__title,
.v-list-item__subtitle {
  flex: none;
}
.share {
  display: flex;
  justify-content: center;
  flex: 1;
  align-items: flex-end;
  align-self: center;
}
</style>
